import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth';
import { AuthComponent } from './components/auth';
import { NewPasswordComponent } from './components/new-password';
import { RecoveryPassComponent } from './components/recovery-pass';
import { SignInComponent } from './components/signin';

const routes: Routes = [
  {
    path: 'autenticacao',
    component: AuthComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'entrar', component: SignInComponent },
      { path: 'recuperar-senha', component: RecoveryPassComponent },
      { path: 'redefinir-senha', component: NewPasswordComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
